import React from "react";
import GenerateurAttestationHebergement from "../components/GenerateurAttestationHebergement";

export default function GenerateurAttestationHebergementPage() {
  return <GenerateurAttestationHebergement />;
}
